/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc410b5a6f105623fd92b95efc5298a4>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "App".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for marketplace apps and integrations across apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const AppIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  name: "AppIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 5.208a.5.5 0 0 0-.243-.429l-5-3a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.43v5.583a.5.5 0 0 0 .243.429l5 3a.5.5 0 0 0 .514 0l5-3a.5.5 0 0 0 .243-.429zm1.5 5.584a2 2 0 0 1-.97 1.715l-5 3a2 2 0 0 1-2.06 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .97-1.715l5-3a2 2 0 0 1 2.06 0l5 3A2 2 0 0 1 15 5.208z"/><path fill="currentcolor" d="M9.5 8a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
AppIcon.displayName = 'AppIcon';
var _default = exports.default = AppIcon;